import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { safeNotificationReturn } from "../utils/notificationReturn";
import { useAuth } from "../context/AuthContext";
import NodeAPI from "../api";
import { getPendingQuiz } from "../utils/pendingQuiz";
import {
  TextField,
  Button,
  Box,
  Paper,
  Typography,
  Link,
  Alert
} from "@mui/material";

const Login = () => {
  const [form, setForm] = useState({ email: "", password: "" });
  const [errorMsg, setErrorMsg] = useState(null);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg(null); // reset error state

    try {
      const { data } = await NodeAPI.post("/auth/login", form, {
        headers: { "Content-Type": "application/json" },
      });

      login(data.user, data.token); // Store in context
      navigate(safeNotificationReturn(searchParams.get("returnTo")) || (getPendingQuiz() ? "/finish-save" : "/categories"), { replace: true });
    } catch (error) {
      console.error("Login error:", error);

      // Extract and show error from response
      const serverMessage = error?.response?.data?.msg || "Login failed!";
      setErrorMsg(serverMessage);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Paper elevation={3} sx={{ padding: 4, width: 350, textAlign: "center" }}>
        <Typography variant="h5" sx={{ mb: 2, fontWeight: "bold" }}>
          Login
        </Typography>

        {errorMsg && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {errorMsg}
          </Alert>
        )}

        {getPendingQuiz() && <Alert severity="info" sx={{ mb: 2 }}>Log in to save your quiz automatically.</Alert>}

        <form onSubmit={handleSubmit}>
          <TextField
            label="Email"
            type="email"
            variant="outlined"
            fullWidth
            margin="normal"
            required
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
          />
          <TextField
            label="Password"
            type="password"
            variant="outlined"
            fullWidth
            margin="normal"
            required
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
          />

          {/* Forgot Password Link */}
          <Box sx={{ textAlign: "right", mt: 1 }}>
            <Link href="/forgot-password" variant="body2" underline="hover">
              Forgot password?
            </Link>
          </Box>

          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2, fontWeight: "bold" }}
          >
            Login
          </Button>

{/* Sign-up Link */}
<Typography variant="body2" sx={{ mt: 2 }}>
  Don’t have an account?{" "}
  <Link href="/register" underline="hover">
    Sign up
  </Link>
</Typography>
        </form>
      </Paper>
    </Box>
  );
};

export default Login;
